export const getRedirectRoute = state => state.redirectReducer.route;
export const getLogoutIsPosting = state => state.redirectReducer.isPosting;
